import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';

import * as BackstageConstants from '../../../constants';
import * as D from '../../../deps';
import BackstagePlayableRowGrid from '../../BackstagePlayableRowGrid';
import BackstageTrackListItem from '../../BackstageTrackListItem';

const ArtistTopSongs = props => {
  const { integration } = useContext(D.AppContext);

  const contentSection = BackstageConstants.BackstageSections.TOP_SONGS;
  const integrationData = { contentSection };

  if (props.topTracks.size <= 0 && !props.isLoading) return null;

  const onSeeAllSongsClick = e => {
    integration.action.clicked({
      ...integrationData,
      destinationUrl: e.currentTarget.pathname,
    });
  };

  const moreUrl = props.shareableUrlPath
    ? D.getBackstageArtistAllSongsPathForShareUrl(props.shareableUrlPath)
    : null;

  const numTracksToRender = BackstageConstants.BackstageConstants.NUM_TOP_TRACKS_TO_RENDER;

  return (
    <BackstagePlayableRowGrid
      contentSection={contentSection}
      title={<FormattedMessage {...BackstageConstants.messages.topSongs} />}
      onSeeAllClick={onSeeAllSongsClick}
      moreUrl={moreUrl}
      moreText={<FormattedMessage {...BackstageConstants.messages.seeAllSongs} />}
    >
      {props.topTracks.slice(0, numTracksToRender).map((pandoraId, index) => (
        <BackstageTrackListItem
          key={pandoraId || index}
          pandoraId={pandoraId}
          playIndex={index}
          playablePandoraId={props.artistPlayId}
          pandoraType={D.PandoraTypes.SONG}
          hasBorderTopBottom={true}
          showAlbumName={true}
        />
      ))}
    </BackstagePlayableRowGrid>
  );
};

ArtistTopSongs.propTypes = {
  artistPlayId: PropTypes.string,
  topTracks: ImmutablePropTypes.listOf(PropTypes.string),
  shareableUrlPath: PropTypes.string,
  isLoading: PropTypes.bool,
};

export default ArtistTopSongs;
